exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".usc-competitions .nc button {\r\n    font-weight: bold;\r\n    background: none;\r\n    border: solid 2px #004795;\r\n    color: #004795;\r\n    border-radius: 4px;\r\n    -moz-border-radius: 4px;\r\n    -webkit-border-radius: 16px;\r\n    padding: 5px 10px;\r\n    cursor: pointer;\r\n}\r\n\r\n.usc-competitions .nc button:hover {\r\n    opacity: 0.8;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-p2w-competitions/usc-p2w-competitions.component.css
// module id = ../../../../../src/app/components/usc-store/usc-p2w-competitions/usc-p2w-competitions.component.css
// module chunks = main